var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBridgeTier2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ce {\n        font-size: 43.27px;\n      }\n\n      .ce, .cf, .cg, .ch {\n        fill: #fff;\n      }\n\n      .ce, .cg {\n        font-family: Montserrat-SemiBold, Montserrat;\n        font-weight: 600;\n      }\n\n      .ci {\n        fill: none;\n      }\n\n      .ci, .cj, .ch, .ck, .cl, .cm, .cn, .co, .cp, .cq, .cr, .cs, .ct, .cu, .cv, .cw, .cx, .cy, .cz, .da, .db, .dc, .dd, .de, .df, .dg, .dh, .di, .dj, .dk, .dl, .dm, .dn, .do, .dp, .dq, .dr, .ds, .dt, .du, .dv, .dw, .dx, .dy, .dz, .ea, .eb, .ec, .ed, .ee, .ef, .eg, .eh, .ei, .ej, .ek, .el, .em, .en, .eo, .ep, .eq, .er, .es, .et, .eu, .ev, .ew, .ex, .ey, .ez, .fa, .fb, .fc, .fd, .fe, .ff, .fg, .fh, .fi, .fj {\n        stroke-width: 0px;\n      }\n\n      .cf {\n        font-family: Montserrat-Black, Montserrat;\n        font-size: 80.03px;\n        font-weight: 800;\n      }\n\n      .fk {\n        filter: url(#b);\n      }\n\n      .fl {\n        letter-spacing: -.02em;\n      }\n\n      .fm {\n        clip-path: url(#f);\n      }\n\n      .fn {\n        letter-spacing: -.02em;\n      }\n\n      .cg {\n        font-size: 103.29px;\n      }\n\n      .cj {\n        fill: #757575;\n      }\n\n      .fo {\n        letter-spacing: -.01em;\n      }\n\n      .ck {\n        fill: url(#ah);\n      }\n\n      .cl {\n        fill: url(#ag);\n      }\n\n      .cm {\n        fill: url(#aa);\n      }\n\n      .cn {\n        fill: url(#ao);\n      }\n\n      .co {\n        fill: url(#af);\n      }\n\n      .cp {\n        fill: url(#ae);\n      }\n\n      .cq {\n        fill: url(#ab);\n      }\n\n      .cr {\n        fill: url(#aj);\n      }\n\n      .cs {\n        fill: url(#ap);\n      }\n\n      .ct {\n        fill: url(#ai);\n      }\n\n      .cu {\n        fill: url(#ad);\n      }\n\n      .cv {\n        fill: url(#an);\n      }\n\n      .cw {\n        fill: url(#am);\n      }\n\n      .cx {\n        fill: url(#ac);\n      }\n\n      .cy {\n        fill: url(#at);\n      }\n\n      .cz {\n        fill: url(#as);\n      }\n\n      .da {\n        fill: url(#bi);\n      }\n\n      .db {\n        fill: url(#bd);\n      }\n\n      .dc {\n        fill: url(#bg);\n      }\n\n      .dd {\n        fill: url(#bj);\n      }\n\n      .de {\n        fill: url(#be);\n      }\n\n      .df {\n        fill: url(#bf);\n      }\n\n      .dg {\n        fill: url(#bo);\n      }\n\n      .dh {\n        fill: url(#bm);\n      }\n\n      .di {\n        fill: url(#bh);\n      }\n\n      .dj {\n        fill: url(#bn);\n      }\n\n      .dk {\n        fill: url(#ba);\n      }\n\n      .dl {\n        fill: url(#bb);\n      }\n\n      .dm {\n        fill: url(#bk);\n      }\n\n      .dn {\n        fill: url(#bc);\n      }\n\n      .do {\n        fill: url(#bx);\n      }\n\n      .dp {\n        fill: url(#bq);\n      }\n\n      .dq {\n        fill: url(#br);\n      }\n\n      .dr {\n        fill: url(#bs);\n      }\n\n      .ds {\n        fill: url(#by);\n      }\n\n      .dt {\n        fill: url(#bt);\n      }\n\n      .du {\n        fill: url(#bl);\n      }\n\n      .dv {\n        fill: url(#bz);\n      }\n\n      .dw {\n        fill: url(#bw);\n      }\n\n      .dx {\n        fill: url(#bp);\n      }\n\n      .dy {\n        fill: url(#bu);\n      }\n\n      .dz {\n        fill: url(#bv);\n      }\n\n      .ea {\n        fill: url(#ar);\n      }\n\n      .eb {\n        fill: url(#ay);\n      }\n\n      .ec {\n        fill: url(#az);\n      }\n\n      .ed {\n        fill: url(#aw);\n      }\n\n      .ee {\n        fill: url(#aq);\n      }\n\n      .ef {\n        fill: url(#ax);\n      }\n\n      .eg {\n        fill: url(#ak);\n      }\n\n      .eh {\n        fill: url(#al);\n      }\n\n      .ei {\n        fill: url(#au);\n      }\n\n      .ej {\n        fill: url(#av);\n      }\n\n      .ek {\n        fill: url(#cb);\n      }\n\n      .el {\n        fill: url(#ca);\n      }\n\n      .em {\n        fill: url(#cd);\n      }\n\n      .en {\n        fill: url(#cc);\n      }\n\n      .eo {\n        fill: url(#v);\n      }\n\n      .ep {\n        fill: url(#e);\n      }\n\n      .eq {\n        fill: url(#y);\n      }\n\n      .er {\n        fill: url(#z);\n      }\n\n      .es {\n        fill: url(#x);\n      }\n\n      .et {\n        fill: url(#w);\n      }\n\n      .eu {\n        fill: url(#u);\n      }\n\n      .ev {\n        fill: url(#t);\n      }\n\n      .ew {\n        fill: url(#d);\n      }\n\n      .ex {\n        fill: url(#s);\n      }\n\n      .ey {\n        fill: url(#j);\n      }\n\n      .ez {\n        fill: url(#q);\n      }\n\n      .fa {\n        fill: url(#r);\n      }\n\n      .fb {\n        fill: url(#i);\n      }\n\n      .fc {\n        fill: url(#h);\n      }\n\n      .fd {\n        fill: url(#m);\n      }\n\n      .fe {\n        fill: url(#g);\n      }\n\n      .ff {\n        fill: url(#o);\n      }\n\n      .fg {\n        fill: url(#p);\n      }\n\n      .fh {\n        fill: url(#k);\n      }\n\n      .fi {\n        fill: url(#n);\n      }\n\n      .fj {\n        fill: url(#l);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    "data-name": "drop-shadow-12",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    "data-name": "Degradado sin nombre 9",
    cx: 300,
    cy: 300,
    fx: 300,
    fy: 300,
    r: 280.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    "data-name": "Degradado sin nombre 66",
    x1: 135.2,
    y1: 85.76,
    x2: 469.95,
    y2: 520.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#916c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b18a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b9964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cfb56c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#e4d48d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#bd9d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9974d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "m300,36.43c-145.56,0-263.57,118-263.57,263.57s118,263.57,263.57,263.57,263.57-118,263.57-263.57S445.56,36.43,300,36.43Zm0,478.18c-118.53,0-214.62-96.09-214.62-214.62s96.09-214.62,214.62-214.62,214.62,96.09,214.62,214.62-96.09,214.62-214.62,214.62Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    "data-name": "Degradado sin nombre 66",
    x1: 190.65,
    y1: 21.72,
    x2: 550.79,
    y2: 454.19,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    "data-name": "Degradado sin nombre 66",
    x1: 197.77,
    y1: 15.79,
    x2: 557.91,
    y2: 448.27,
    gradientTransform: "translate(438.83 -170.89) rotate(85.11)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    "data-name": "Degradado sin nombre 66",
    x1: 204.31,
    y1: 10.35,
    x2: 564.45,
    y2: 442.83,
    gradientTransform: "translate(422.67 -191.35) rotate(80.23)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    "data-name": "Degradado sin nombre 66",
    x1: 210.22,
    y1: 5.42,
    x2: 570.36,
    y2: 437.9,
    gradientTransform: "translate(404.76 -208.22) rotate(75.39)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    "data-name": "Degradado sin nombre 66",
    x1: 215.48,
    y1: 1.05,
    x2: 575.62,
    y2: 433.52,
    gradientTransform: "translate(384.67 -221.48) rotate(70.49)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    "data-name": "Degradado sin nombre 66",
    x1: 220.03,
    y1: -2.74,
    x2: 580.17,
    y2: 429.74,
    gradientTransform: "translate(363.29 -230.94) rotate(65.65)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    "data-name": "Degradado sin nombre 66",
    x1: 223.84,
    y1: -5.92,
    x2: 583.98,
    y2: 426.56,
    gradientTransform: "translate(340.12 -236.57) rotate(60.77)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    "data-name": "Degradado sin nombre 66",
    x1: 226.89,
    y1: -8.46,
    x2: 587.04,
    y2: 424.02,
    gradientTransform: "translate(315.44 -238.29) rotate(55.87)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    "data-name": "Degradado sin nombre 66",
    x1: 229.16,
    y1: -10.35,
    x2: 589.3,
    y2: 422.13,
    gradientTransform: "translate(289.92 -236.17) rotate(51.01)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    "data-name": "Degradado sin nombre 66",
    x1: 230.63,
    y1: -11.57,
    x2: 590.77,
    y2: 420.9,
    gradientTransform: "translate(262.97 -230.04) rotate(46.09)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    "data-name": "Degradado sin nombre 66",
    x1: 231.28,
    y1: -12.12,
    x2: 591.43,
    y2: 420.36,
    gradientTransform: "translate(235.75 -220.25) rotate(41.25)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    "data-name": "Degradado sin nombre 66",
    x1: 231.12,
    y1: -11.98,
    x2: 591.26,
    y2: 420.49,
    gradientTransform: "translate(207.72 -206.62) rotate(36.37)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    "data-name": "Degradado sin nombre 66",
    x1: 230.15,
    y1: -11.17,
    x2: 590.29,
    y2: 421.31,
    gradientTransform: "translate(179.4 -189.4) rotate(31.52)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    "data-name": "Degradado sin nombre 66",
    x1: 228.36,
    y1: -9.68,
    x2: 588.5,
    y2: 422.79,
    gradientTransform: "translate(151.05 -168.77) rotate(26.68)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    "data-name": "Degradado sin nombre 66",
    x1: 225.78,
    y1: -7.53,
    x2: 585.92,
    y2: 424.94,
    gradientTransform: "translate(121.86 -144.12) rotate(21.72)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    "data-name": "Degradado sin nombre 66",
    x1: 222.42,
    y1: -4.74,
    x2: 582.56,
    y2: 427.74,
    gradientTransform: "translate(93.97 -117.11) rotate(16.92)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    "data-name": "Degradado sin nombre 66",
    x1: 218.31,
    y1: -1.32,
    x2: 578.45,
    y2: 431.16,
    gradientTransform: "translate(65.85 -86.53) rotate(12.02)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    "data-name": "Degradado sin nombre 66",
    x1: 213.48,
    y1: 2.71,
    x2: 573.62,
    y2: 435.19,
    gradientTransform: "translate(38.33 -53.05) rotate(7.11)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    "data-name": "Degradado sin nombre 66",
    x1: 207.96,
    y1: 7.31,
    x2: 568.1,
    y2: 439.78,
    gradientTransform: "translate(11.95 -17.39) rotate(2.26)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    "data-name": "Degradado sin nombre 66",
    x1: 201.79,
    y1: 12.44,
    x2: 561.93,
    y2: 444.92,
    gradientTransform: "translate(732.86 -153.63) rotate(87.39)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    "data-name": "Degradado sin nombre 66",
    x1: 195.02,
    y1: 18.08,
    x2: 555.16,
    y2: 450.56,
    gradientTransform: "translate(704.1 -164.35) rotate(82.52)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    "data-name": "Degradado sin nombre 66",
    x1: 187.69,
    y1: 24.18,
    x2: 547.84,
    y2: 456.66,
    gradientTransform: "translate(672.42 -172.77) rotate(77.64)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    "data-name": "Degradado sin nombre 66",
    x1: 179.87,
    y1: 30.7,
    x2: 540.01,
    y2: 463.18,
    gradientTransform: "translate(638.05 -178.84) rotate(72.77)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    "data-name": "Degradado sin nombre 66",
    x1: 171.6,
    y1: 37.59,
    x2: 531.74,
    y2: 470.07,
    gradientTransform: "translate(601.23 -182.51) rotate(67.9)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    "data-name": "Degradado sin nombre 66",
    x1: 162.94,
    y1: 44.8,
    x2: 523.08,
    y2: 477.27,
    gradientTransform: "translate(562.24 -183.75) rotate(63.02)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    "data-name": "Degradado sin nombre 66",
    x1: 153.96,
    y1: 52.27,
    x2: 514.1,
    y2: 484.75,
    gradientTransform: "translate(521.34 -182.55) rotate(58.15)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    "data-name": "Degradado sin nombre 66",
    x1: 144.72,
    y1: 59.97,
    x2: 504.87,
    y2: 492.44,
    gradientTransform: "translate(478.85 -178.93) rotate(53.27)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    "data-name": "Degradado sin nombre 66",
    x1: 135.3,
    y1: 67.82,
    x2: 495.44,
    y2: 500.29,
    gradientTransform: "translate(435.06 -172.91) rotate(48.4)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    "data-name": "Degradado sin nombre 66",
    x1: 125.75,
    y1: 75.77,
    x2: 485.89,
    y2: 508.25,
    gradientTransform: "translate(390.3 -164.53) rotate(43.53)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    "data-name": "Degradado sin nombre 66",
    x1: 116.15,
    y1: 83.76,
    x2: 476.29,
    y2: 516.24,
    gradientTransform: "translate(344.88 -153.85) rotate(38.65)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    "data-name": "Degradado sin nombre 66",
    x1: 106.56,
    y1: 91.75,
    x2: 466.7,
    y2: 524.22,
    gradientTransform: "translate(299.13 -140.96) rotate(33.78)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    "data-name": "Degradado sin nombre 66",
    x1: 97.06,
    y1: 99.66,
    x2: 457.2,
    y2: 532.14,
    gradientTransform: "translate(253.4 -125.94) rotate(28.9)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    "data-name": "Degradado sin nombre 66",
    x1: 87.71,
    y1: 107.44,
    x2: 447.85,
    y2: 539.92,
    gradientTransform: "translate(208 -108.9) rotate(24.03)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    "data-name": "Degradado sin nombre 66",
    x1: 78.59,
    y1: 115.04,
    x2: 438.73,
    y2: 547.52,
    gradientTransform: "translate(163.27 -89.96) rotate(19.15)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    "data-name": "Degradado sin nombre 66",
    x1: 69.75,
    y1: 122.4,
    x2: 429.89,
    y2: 554.87,
    gradientTransform: "translate(119.53 -69.27) rotate(14.28)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    "data-name": "Degradado sin nombre 66",
    x1: 61.26,
    y1: 129.47,
    x2: 421.41,
    y2: 561.94,
    gradientTransform: "translate(77.08 -46.97) rotate(9.41)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    "data-name": "Degradado sin nombre 66",
    x1: 53.19,
    y1: 136.19,
    x2: 413.34,
    y2: 568.67,
    gradientTransform: "translate(36.26 -23.23) rotate(4.53)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    "data-name": "Degradado sin nombre 66",
    x1: 45.59,
    y1: 142.52,
    x2: 405.73,
    y2: 574.99,
    gradientTransform: "translate(744.19 145.02) rotate(89.64)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    "data-name": "Degradado sin nombre 66",
    x1: 38.52,
    y1: 148.41,
    x2: 398.66,
    y2: 580.88,
    gradientTransform: "translate(705.15 120.4) rotate(84.79)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    "data-name": "Degradado sin nombre 66",
    x1: 32.02,
    y1: 153.82,
    x2: 392.16,
    y2: 586.29,
    gradientTransform: "translate(664.01 96.77) rotate(79.91)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    "data-name": "Degradado sin nombre 66",
    x1: 26.15,
    y1: 158.71,
    x2: 386.29,
    y2: 591.18,
    gradientTransform: "translate(621.43 74.74) rotate(75.04)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    "data-name": "Degradado sin nombre 66",
    x1: 20.94,
    y1: 163.04,
    x2: 381.09,
    y2: 595.52,
    gradientTransform: "translate(577.5 54.26) rotate(70.16)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    "data-name": "Degradado sin nombre 66",
    x1: 16.44,
    y1: 166.79,
    x2: 376.59,
    y2: 599.27,
    gradientTransform: "translate(532.86 35.73) rotate(65.32)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    "data-name": "Degradado sin nombre 66",
    x1: 12.68,
    y1: 169.92,
    x2: 372.82,
    y2: 602.4,
    gradientTransform: "translate(487.04 18.72) rotate(60.4)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    "data-name": "Degradado sin nombre 66",
    x1: 9.68,
    y1: 172.42,
    x2: 369.82,
    y2: 604.9,
    gradientTransform: "translate(441.4 4.07) rotate(55.54)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    "data-name": "Degradado sin nombre 66",
    x1: 7.47,
    y1: 174.26,
    x2: 367.61,
    y2: 606.74,
    gradientTransform: "translate(395.84 -8.45) rotate(50.68)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    "data-name": "Degradado sin nombre 66",
    x1: 6.06,
    y1: 175.44,
    x2: 366.2,
    y2: 607.91,
    gradientTransform: "translate(350.4 -18.86) rotate(45.8)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    "data-name": "Degradado sin nombre 66",
    x1: 5.46,
    y1: 175.93,
    x2: 365.61,
    y2: 608.41,
    gradientTransform: "translate(306.01 -26.84) rotate(40.96)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    "data-name": "Degradado sin nombre 66",
    x1: 5.68,
    y1: 175.75,
    x2: 365.82,
    y2: 608.23,
    gradientTransform: "translate(262.4 -32.55) rotate(36.09)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    "data-name": "Degradado sin nombre 66",
    x1: 6.71,
    y1: 174.89,
    x2: 366.86,
    y2: 607.37,
    gradientTransform: "translate(219.64 -35.91) rotate(31.15)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    "data-name": "Degradado sin nombre 66",
    x1: 8.56,
    y1: 173.36,
    x2: 368.7,
    y2: 605.83,
    gradientTransform: "translate(179.42 -36.74) rotate(26.33)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    "data-name": "Degradado sin nombre 66",
    x1: 11.19,
    y1: 171.16,
    x2: 371.33,
    y2: 603.64,
    gradientTransform: "translate(140.3 -35.16) rotate(21.4)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    "data-name": "Degradado sin nombre 66",
    x1: 14.6,
    y1: 168.32,
    x2: 374.74,
    y2: 600.8,
    gradientTransform: "translate(104.25 -31.2) rotate(16.59)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    "data-name": "Degradado sin nombre 66",
    x1: 18.77,
    y1: 164.86,
    x2: 378.91,
    y2: 597.33,
    gradientTransform: "translate(70.2 -24.82) rotate(11.71)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    "data-name": "Degradado sin nombre 66",
    x1: 23.65,
    y1: 160.79,
    x2: 383.79,
    y2: 593.27,
    gradientTransform: "translate(38.7 -16.02) rotate(6.81)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    "data-name": "Degradado sin nombre 66",
    x1: 29.21,
    y1: 156.15,
    x2: 389.36,
    y2: 588.63,
    gradientTransform: "translate(10.49 -5.05) rotate(1.95)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    "data-name": "Degradado sin nombre 66",
    x1: 35.43,
    y1: 150.98,
    x2: 395.57,
    y2: 583.46,
    gradientTransform: "translate(437.39 124.37) rotate(87.05)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    "data-name": "Degradado sin nombre 66",
    x1: 42.24,
    y1: 145.31,
    x2: 402.38,
    y2: 577.79,
    gradientTransform: "translate(410.76 88.92) rotate(82.18)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    "data-name": "Degradado sin nombre 66",
    x1: 49.6,
    y1: 139.18,
    x2: 409.74,
    y2: 571.65,
    gradientTransform: "translate(383.34 56.06) rotate(77.3)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    "data-name": "Degradado sin nombre 66",
    x1: 57.46,
    y1: 132.63,
    x2: 417.6,
    y2: 565.11,
    gradientTransform: "translate(355.32 26.03) rotate(72.43)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    "data-name": "Degradado sin nombre 66",
    x1: 65.76,
    y1: 125.72,
    x2: 425.9,
    y2: 558.2,
    gradientTransform: "translate(326.89 -.96) rotate(67.55)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    "data-name": "Degradado sin nombre 66",
    x1: 74.44,
    y1: 118.49,
    x2: 434.58,
    y2: 550.97,
    gradientTransform: "translate(298.27 -24.71) rotate(62.68)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    "data-name": "Degradado sin nombre 66",
    x1: 83.44,
    y1: 111,
    x2: 443.58,
    y2: 543.47,
    gradientTransform: "translate(269.66 -45.05) rotate(57.81)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    "data-name": "Degradado sin nombre 66",
    x1: 92.7,
    y1: 103.29,
    x2: 452.84,
    y2: 535.77,
    gradientTransform: "translate(241.27 -61.82) rotate(52.93)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    "data-name": "Degradado sin nombre 66",
    x1: 102.13,
    y1: 95.43,
    x2: 462.27,
    y2: 527.91,
    gradientTransform: "translate(213.31 -74.92) rotate(48.06)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    "data-name": "Degradado sin nombre 66",
    x1: 111.69,
    y1: 87.48,
    x2: 471.83,
    y2: 519.95,
    gradientTransform: "translate(185.97 -84.25) rotate(43.18)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    "data-name": "Degradado sin nombre 66",
    x1: 121.29,
    y1: 79.48,
    x2: 481.43,
    y2: 511.96,
    gradientTransform: "translate(159.46 -89.73) rotate(38.31)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    "data-name": "Degradado sin nombre 66",
    x1: 130.87,
    y1: 71.5,
    x2: 491.02,
    y2: 503.98,
    gradientTransform: "translate(133.96 -91.33) rotate(33.44)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    "data-name": "Degradado sin nombre 66",
    x1: 140.37,
    y1: 63.59,
    x2: 500.51,
    y2: 496.07,
    gradientTransform: "translate(109.67 -89.04) rotate(28.56)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    "data-name": "Degradado sin nombre 66",
    x1: 149.7,
    y1: 55.82,
    x2: 509.84,
    y2: 488.3,
    gradientTransform: "translate(86.75 -82.87) rotate(23.69)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    "data-name": "Degradado sin nombre 66",
    x1: 158.81,
    y1: 48.24,
    x2: 518.95,
    y2: 480.72,
    gradientTransform: "translate(65.37 -72.86) rotate(18.81)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    "data-name": "Degradado sin nombre 66",
    x1: 167.62,
    y1: 40.9,
    x2: 527.76,
    y2: 473.38,
    gradientTransform: "translate(45.69 -59.1) rotate(13.94)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    "data-name": "Degradado sin nombre 66",
    x1: 176.08,
    y1: 33.86,
    x2: 536.22,
    y2: 466.33,
    gradientTransform: "translate(27.86 -41.68) rotate(9.06)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    "data-name": "Degradado sin nombre 66",
    x1: 184.12,
    y1: 27.16,
    x2: 544.26,
    y2: 459.64,
    gradientTransform: "translate(11.98 -20.73) rotate(4.19)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc",
    "data-name": "Degradado sin nombre 66",
    x1: 162.41,
    y1: 256.75,
    x2: 487.92,
    y2: 623.82,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd",
    "data-name": "Degradado sin nombre 66",
    x1: 113.88,
    y1: 299.79,
    x2: 439.39,
    y2: 666.85,
    xlinkHref: "#e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fk"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ew",
    cx: 300,
    cy: 300,
    r: 280.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ep",
    d: "m300,566.91c-147.18,0-266.91-119.74-266.91-266.91S152.83,33.09,300,33.09s266.91,119.74,266.91,266.91-119.73,266.91-266.91,266.91Zm0-527.13c-143.48,0-260.22,116.73-260.22,260.22s116.73,260.22,260.22,260.22,260.22-116.73,260.22-260.22S443.49,39.78,300,39.78Zm0,478.18c-120.19,0-217.96-97.78-217.96-217.96s97.78-217.96,217.96-217.96,217.96,97.78,217.96,217.96-97.78,217.96-217.96,217.96Zm0-429.23c-116.49,0-211.27,94.78-211.27,211.27s94.78,211.27,211.27,211.27,211.27-94.78,211.27-211.27-94.78-211.27-211.27-211.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fm"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fe",
    x: 298.33,
    y: 6.05,
    width: 3.35,
    height: 293.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fc",
    x: 165.51,
    y: 151.88,
    width: 293.95,
    height: 3.35,
    transform: "translate(132.84 451.81) rotate(-85.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fb",
    x: 177.91,
    y: 153.47,
    width: 293.95,
    height: 3.35,
    transform: "translate(116.87 449) rotate(-80.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ey",
    x: 190.13,
    y: 156.11,
    width: 293.95,
    height: 3.35,
    transform: "translate(99.39 444.19) rotate(-75.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fh",
    x: 202.08,
    y: 159.78,
    width: 293.95,
    height: 3.35,
    transform: "translate(80.3 436.55) rotate(-70.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fj",
    x: 213.67,
    y: 164.45,
    width: 293.95,
    height: 3.35,
    transform: "translate(60.6 426.19) rotate(-65.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fd",
    x: 224.83,
    y: 170.09,
    width: 293.94,
    height: 3.35,
    transform: "translate(40.35 412.33) rotate(-60.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fi",
    x: 235.47,
    y: 176.65,
    width: 293.94,
    height: 3.35,
    transform: "translate(20.24 394.82) rotate(-55.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ff",
    x: 245.51,
    y: 184.09,
    width: 293.94,
    height: 3.35,
    transform: "translate(1.15 373.94) rotate(-51.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fg",
    x: 254.88,
    y: 192.37,
    width: 293.95,
    height: 3.35,
    transform: "translate(-16.63 348.99) rotate(-46.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ez",
    x: 263.51,
    y: 201.4,
    width: 293.95,
    height: 3.35,
    transform: "translate(-32.04 321.03) rotate(-41.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fa",
    x: 271.35,
    y: 211.14,
    width: 293.95,
    height: 3.35,
    transform: "translate(-44.71 289.55) rotate(-36.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ex",
    x: 278.33,
    y: 221.51,
    width: 293.94,
    height: 3.35,
    transform: "translate(-53.93 255.24) rotate(-31.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ev",
    x: 284.4,
    y: 232.43,
    width: 293.94,
    height: 3.35,
    transform: "translate(-59.19 218.62) rotate(-26.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eu",
    x: 289.53,
    y: 243.84,
    width: 293.94,
    height: 3.35,
    transform: "translate(-59.87 178.98) rotate(-21.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eo",
    x: 293.66,
    y: 255.63,
    width: 293.94,
    height: 3.35,
    transform: "translate(-55.81 139.39) rotate(-16.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "et",
    x: 296.78,
    y: 267.73,
    width: 293.95,
    height: 3.35,
    transform: "translate(-46.38 98.35) rotate(-12.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "es",
    x: 298.86,
    y: 280.06,
    width: 293.94,
    height: 3.35,
    transform: "translate(-31.46 57.39) rotate(-7.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eq",
    x: 299.89,
    y: 292.51,
    width: 293.94,
    height: 3.35,
    transform: "translate(-11.25 17.85) rotate(-2.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "er",
    x: 445.15,
    y: 159.72,
    width: 3.35,
    height: 293.94,
    transform: "translate(120.12 739.09) rotate(-87.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cm",
    x: 444.05,
    y: 172.17,
    width: 3.35,
    height: 293.95,
    transform: "translate(71.26 719.51) rotate(-82.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cq",
    x: 441.89,
    y: 184.48,
    width: 3.35,
    height: 293.94,
    transform: "translate(24.88 693.82) rotate(-77.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cx",
    x: 438.7,
    y: 196.56,
    width: 3.35,
    height: 293.95,
    transform: "translate(-18.19 662.39) rotate(-72.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cu",
    x: 434.5,
    y: 208.33,
    width: 3.35,
    height: 293.94,
    transform: "translate(-57.15 625.72) rotate(-67.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cp",
    x: 429.31,
    y: 219.7,
    width: 3.35,
    height: 293.94,
    transform: "translate(-91.31 584.41) rotate(-63.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "co",
    x: 423.17,
    y: 230.59,
    width: 3.35,
    height: 293.95,
    transform: "translate(-120.07 539.17) rotate(-58.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cl",
    x: 416.13,
    y: 240.92,
    width: 3.35,
    height: 293.95,
    transform: "translate(-142.94 490.8) rotate(-53.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ck",
    x: 408.23,
    y: 250.61,
    width: 3.35,
    height: 293.95,
    transform: "translate(-159.55 440.14) rotate(-48.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ct",
    x: 399.54,
    y: 259.59,
    width: 3.35,
    height: 293.95,
    transform: "translate(-169.69 388.08) rotate(-43.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cr",
    x: 390.12,
    y: 267.81,
    width: 3.35,
    height: 293.95,
    transform: "translate(-173.24 335.56) rotate(-38.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eg",
    x: 380.04,
    y: 275.19,
    width: 3.35,
    height: 293.95,
    transform: "translate(-170.28 283.47) rotate(-33.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eh",
    x: 369.36,
    y: 281.69,
    width: 3.34,
    height: 293.94,
    transform: "translate(-160.97 232.72) rotate(-28.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cw",
    x: 358.18,
    y: 287.26,
    width: 3.34,
    height: 293.95,
    transform: "translate(-145.63 184.16) rotate(-24.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cv",
    x: 346.55,
    y: 291.86,
    width: 3.35,
    height: 293.95,
    transform: "translate(-124.71 138.55) rotate(-19.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cn",
    x: 334.58,
    y: 295.46,
    width: 3.35,
    height: 293.95,
    transform: "translate(-98.75 96.62) rotate(-14.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cs",
    x: 322.35,
    y: 298.02,
    width: 3.35,
    height: 293.95,
    transform: "translate(-68.37 58.94) rotate(-9.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ee",
    x: 309.94,
    y: 299.54,
    width: 3.35,
    height: 293.95,
    transform: "translate(-34.31 26.02) rotate(-4.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ea",
    x: 152.15,
    y: 445.3,
    width: 293.95,
    height: 3.35,
    transform: "translate(-149.73 743.25) rotate(-89.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cz",
    x: 139.67,
    y: 444.69,
    width: 293.95,
    height: 3.34,
    transform: "translate(-183.9 691.31) rotate(-84.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cy",
    x: 127.28,
    y: 443.03,
    width: 293.95,
    height: 3.35,
    transform: "translate(-211.62 636.78) rotate(-79.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ei",
    x: 115.08,
    y: 440.31,
    width: 293.95,
    height: 3.35,
    transform: "translate(-232.6 581.08) rotate(-75.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ej",
    x: 103.15,
    y: 436.58,
    width: 293.95,
    height: 3.35,
    transform: "translate(-247 524.83) rotate(-70.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ed",
    x: 91.58,
    y: 431.84,
    width: 293.95,
    height: 3.35,
    transform: "translate(-254.97 469.27) rotate(-65.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ef",
    x: 80.46,
    y: 426.14,
    width: 293.95,
    height: 3.35,
    transform: "translate(-256.88 414.21) rotate(-60.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eb",
    x: 69.86,
    y: 419.51,
    width: 293.95,
    height: 3.35,
    transform: "translate(-253.13 361.63) rotate(-55.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ec",
    x: 59.87,
    y: 412,
    width: 293.95,
    height: 3.35,
    transform: "translate(-244.26 311.6) rotate(-50.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dk",
    x: 50.55,
    y: 403.68,
    width: 293.95,
    height: 3.35,
    transform: "translate(-230.78 264.34) rotate(-45.8)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dl",
    x: 41.97,
    y: 394.59,
    width: 293.95,
    height: 3.35,
    transform: "translate(-213.5 220.86) rotate(-40.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dn",
    x: 34.19,
    y: 384.8,
    width: 293.95,
    height: 3.35,
    transform: "translate(-192.88 180.86) rotate(-36.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "db",
    x: 27.27,
    y: 374.39,
    width: 293.95,
    height: 3.35,
    transform: "translate(-169.4 144.34) rotate(-31.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "de",
    x: 21.26,
    y: 363.43,
    width: 293.95,
    height: 3.35,
    transform: "translate(-144.5 112.52) rotate(-26.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "df",
    x: 16.2,
    y: 352,
    width: 293.95,
    height: 3.34,
    transform: "translate(-117.8 83.93) rotate(-21.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dc",
    x: 12.14,
    y: 340.18,
    width: 293.95,
    height: 3.35,
    transform: "translate(-91 59.68) rotate(-16.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "di",
    x: 9.09,
    y: 328.06,
    width: 293.95,
    height: 3.35,
    transform: "translate(-63.7 38.55) rotate(-11.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "da",
    x: 7.09,
    y: 315.72,
    width: 293.95,
    height: 3.35,
    transform: "translate(-36.53 20.49) rotate(-6.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dd",
    x: 6.14,
    y: 303.26,
    width: 293.95,
    height: 3.35,
    transform: "translate(-10.31 5.4) rotate(-1.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dm",
    x: 151.55,
    y: 145.46,
    width: 3.35,
    height: 293.95,
    transform: "translate(-146.71 430.41) rotate(-87.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "du",
    x: 152.72,
    y: 133.02,
    width: 3.35,
    height: 293.95,
    transform: "translate(-144.01 394.84) rotate(-82.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dh",
    x: 154.95,
    y: 120.72,
    width: 3.35,
    height: 293.95,
    transform: "translate(-138.95 361.64) rotate(-77.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dj",
    x: 158.21,
    y: 108.65,
    width: 3.35,
    height: 293.95,
    transform: "translate(-132.08 330.88) rotate(-72.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dg",
    x: 162.49,
    y: 96.91,
    width: 3.35,
    height: 293.95,
    transform: "translate(-123.92 302.49) rotate(-67.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dx",
    x: 167.75,
    y: 85.57,
    width: 3.35,
    height: 293.95,
    transform: "translate(-114.94 276.34) rotate(-62.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dp",
    x: 173.95,
    y: 74.72,
    width: 3.35,
    height: 293.95,
    transform: "translate(-105.55 252.2) rotate(-57.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dq",
    x: 181.05,
    y: 64.44,
    width: 3.35,
    height: 293.95,
    transform: "translate(-96.1 229.78) rotate(-52.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dr",
    x: 189.01,
    y: 54.79,
    width: 3.35,
    height: 293.95,
    transform: "translate(-86.84 208.74) rotate(-48.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dt",
    x: 197.75,
    y: 45.86,
    width: 3.35,
    height: 293.95,
    transform: "translate(-77.95 188.7) rotate(-43.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dy",
    x: 207.22,
    y: 37.7,
    width: 3.35,
    height: 293.95,
    transform: "translate(-69.5 169.26) rotate(-38.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dz",
    x: 217.35,
    y: 30.38,
    width: 3.35,
    height: 293.95,
    transform: "translate(-61.47 150.03) rotate(-33.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dw",
    x: 228.06,
    y: 23.94,
    width: 3.35,
    height: 293.95,
    transform: "translate(-53.76 130.63) rotate(-28.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "do",
    x: 239.28,
    y: 18.43,
    width: 3.35,
    height: 293.95,
    transform: "translate(-46.15 110.74) rotate(-23.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ds",
    x: 250.93,
    y: 13.91,
    width: 3.35,
    height: 293.95,
    transform: "translate(-38.38 90.05) rotate(-18.81)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dv",
    x: 262.93,
    y: 10.38,
    width: 3.34,
    height: 293.95,
    transform: "translate(-30.11 68.37) rotate(-13.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "el",
    x: 275.17,
    y: 7.89,
    width: 3.35,
    height: 293.95,
    transform: "translate(-20.94 45.55) rotate(-9.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ek",
    x: 287.59,
    y: 6.45,
    width: 3.35,
    height: 293.95,
    transform: "translate(-10.44 21.55) rotate(-4.19)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cf",
    transform: "translate(135.15 250.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BRIDGE")), /*#__PURE__*/React.createElement("text", {
    className: "cg",
    transform: "translate(156.53 343.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "fo",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.84,
    y: 0
  }, "ier 2")), /*#__PURE__*/React.createElement("text", {
    className: "ce",
    transform: "translate(161.22 406.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BORR"), /*#__PURE__*/React.createElement("tspan", {
    className: "fl",
    x: 132.62,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "fn",
    x: 168.1,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 216.95,
    y: 0
  }, "ER")), /*#__PURE__*/React.createElement("rect", {
    className: "ch",
    x: 159.73,
    y: 354.93,
    width: 280.54,
    height: 5.85
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cj",
    cx: 123.78,
    cy: 300,
    r: 12.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cj",
    cx: 476.23,
    cy: 300,
    r: 12.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "en",
    d: "m339.58,444.37l5.46,6.51c.34.4.85.61,1.37.56l8.46-.81c1.31-.13,2.2,1.31,1.5,2.43l-4.5,7.2c-.28.44-.32,1-.11,1.48l3.38,7.79c.53,1.21-.57,2.5-1.85,2.18l-8.24-2.06c-.51-.13-1.05,0-1.44.35l-6.37,5.62c-.99.87-2.55.23-2.65-1.08l-.59-8.47c-.04-.52-.33-1-.78-1.26l-7.31-4.32c-1.14-.67-1.01-2.36.21-2.85l7.88-3.18c.49-.2.85-.62.96-1.13l1.85-8.29c.29-1.29,1.93-1.69,2.78-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "em",
    d: "m260.42,444.37l-5.46,6.51c-.34.4-.85.61-1.37.56l-8.46-.81c-1.32-.13-2.2,1.31-1.5,2.43l4.5,7.2c.28.44.32,1,.11,1.48l-3.38,7.79c-.53,1.21.57,2.5,1.85,2.18l8.24-2.06c.51-.13,1.05,0,1.44.35l6.37,5.62c.99.87,2.55.23,2.65-1.08l.59-8.47c.04-.52.33-1,.78-1.26l7.31-4.32c1.14-.67,1.01-2.36-.21-2.85l-7.88-3.18c-.49-.2-.85-.62-.96-1.13l-1.85-8.29c-.29-1.29-1.93-1.69-2.78-.68Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeTier2);
export default __webpack_public_path__ + "bridge-tier-2.502d20f.svg";
export { ForwardRef as ReactComponent };